export { default } from './HTMLElementType';